// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { Button, buttonTypes, buttonSizes } from 'moods-react/Button';
import { envUrl } from '../services/environment/EnvironmentService';
import dashboardMessages from '../../data/dashboard';
import DashboardLoadingPlaceholder from './DashboardLoadingPlaceholderComponent';

type Props = {
  isLoading: boolean,
  total: number,
  history: Object,
};

type Context = {
  intl: Object,
};

const getText = (total) => {
  if (total === 1) {
    return dashboardMessages.dashboardProductInLibraryText;
  }
  return dashboardMessages.dashboardProductsInLibraryText;
};

const TotalProductsComponent = ({ isLoading, total, history }: Props, { intl }: Context) => (
  <div className="u-marginTop-s u-marginTop-m@large u-padding-horizontal-m u-padding-vertical-s u-padding-vertical-m@large dashboard-page__total-products dashboard-page__item">
    {isLoading ? (
      <DashboardLoadingPlaceholder type="triple" />
    ) : (
      <div>
        <div className="u-fontSize-xxxl u-fontSize-xxxxxl@large u-fontFamily-secondaryMedium dashboard-page__total-products-amount">
          {total}
        </div>
        <div className="u-fontSize-m">{intl.formatMessage(getText(total))}</div>
        <div className="dashboard-page__total-products-button">
          <Button
            type={buttonTypes.PRIMARY}
            size={buttonSizes.SMALL}
            onClick={() => history.push(envUrl('/products'))}
            isFullWidth
            className="u-marginTop-xs u-marginTop-m@large"
          >
            {intl.formatMessage(dashboardMessages.dashboardStartOrderingButtonText)}
          </Button>
        </div>
      </div>
    )}
  </div>
);

TotalProductsComponent.displayName = 'TotalProducts';

TotalProductsComponent.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(TotalProductsComponent);
